import { useMemo } from "react";

import { fieldIsValid } from "../../../../lib/helper";
import { Select } from "../../../../../common/Atoms/Select";
import { useSettings } from "../../../../hooks/useSettings";
import { useCustomDomain } from "../../../../hooks/useCustomDomain";

import { IFieldProps } from "./Fields/fieldProps";

export function SenderProfileSelector({
  handleChange,
  policyFormData,
  invalids,
  anchor,
}: IFieldProps & {
  anchor?: `top` | `bottom`;
}) {
  const { data: settings } = useSettings();
  const { data: customDomain } = useCustomDomain();
  const domainActive = !!customDomain?.verified && !!customDomain?.domain;

  const fromPostfix = domainActive ? `@${customDomain.domain}` : `@mail.paidnice.com`;

  const options = useMemo(() => {
    const senderProfiles = settings?.senderProfiles;

    if (!senderProfiles) {
      return [];
    }

    return senderProfiles.map(profile => {
      const fromAddressDisplay = domainActive ? profile.fromAddress : `no-reply`;

      return {
        label: profile.name,
        description: `From: ${fromAddressDisplay}${fromPostfix}. Reply-To: ${profile.replyToAddress}`,
        value: profile.id,
        badge: profile.default ? `Default` : undefined,
        badgeColor: profile.default ? `blue` : undefined,
      };
    });
  }, [settings, domainActive, fromPostfix]);

  function onChange({ value }) {
    return handleChange({
      value,
      name: `email_sender_profile_id`,
    });
  }

  return (
    <>
      <Select
        options={ options }
        label={ `Email Sender Profile` }
        selected={ policyFormData.email_sender_profile_id || null }
        onChange={ onChange }
        name={ `email_sender_profile_id` }
        invalid={ fieldIsValid(`email_sender_profile_id`, invalids) }
        emptyText={ `Use Default Profile` }
        anchor={ anchor }
        nullable
      />
    </>
  );
}
